// @ts-nocheck
/* eslint-disable */
export const appChevronUp24Icon = {
    data: `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M17.5 15.5L12 9.5L6.5 15.5" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>`,
    name: 'chevron-up-24' as const
};